(function () {
    var isProd = /.*(rbs\.co.uk|natwest\.com)$/.test(window.location.hostname);
    var scriptSrc = `https://client.px-cloud.net/${isProd ? 'PXuH2dJvgZ' : 'PXL25WnbYu'}/main.min.js`;

    var codeDefenderScript = document.createElement('script');
    codeDefenderScript.type = 'text/javascript';
    codeDefenderScript.async = false;
    codeDefenderScript.src = scriptSrc;
    document.head.appendChild(codeDefenderScript);
})();
